import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useAgentBuilderQuery } from '@/agentBuilder/agentBuilder.queries';
import { useCurrentAgentBuilderId } from '@/agentBuilder/agentBuilder.store';
import { sqItemTableDefinitionStore, sqWorkbookStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { FAVICON } from '@/main/app.constants';
import { useRoutingData } from '@/main/useRoutingData.hook';
import { getFavIconElement } from '@/utilities/dom.utilities';
import { getDocumentTitle } from '@/utilities/utilities';

/**
 * This component manages the tab title display as well as the favicon
 */
export const TabTitle = () => {
  const { isWorksheetDisplayed, isViewMode, isTreeBuilder } = useRoutingData();
  const location = useLocation();
  const isAgentBuilder = !!location.pathname?.startsWith('/agent-builder');
  const isReport = useFluxPath(sqWorkbookStore, () => sqWorkbookStore.isTopic);
  const isVantage = useFluxPath(sqWorkbookStore, () => sqWorkbookStore.isVantage);
  const isActionBoard = useFluxPath(sqWorkbookStore, () => sqWorkbookStore.isActionBoard);
  const workbookName = useFluxPath(sqWorkbookStore, () => sqWorkbookStore.name);
  const worksheets = useFluxPath(sqWorkbookStore, () => sqWorkbookStore.worksheets);
  const treeBuilderName = useFluxPath(sqItemTableDefinitionStore, () => sqItemTableDefinitionStore.name);
  const currentAgentBuilderId = useCurrentAgentBuilderId(isAgentBuilder);
  const agentBuilderName = useAgentBuilderQuery(currentAgentBuilderId).data?.name;

  const { worksheetId } = useParams();
  useEffect(() => {
    let favicon = FAVICON.WORKBENCH;
    if (isWorksheetDisplayed || isViewMode) {
      if (isReport) {
        favicon = FAVICON.BLUE;
      } else if (isVantage) {
        favicon = FAVICON.PURPLE;
      } else if (isActionBoard) {
        favicon = FAVICON.ACTION_BOARD;
      } else {
        favicon = FAVICON.GREEN;
      }
    }
    getFavIconElement().href = favicon;
    document.title = getDocumentTitle(location.pathname, worksheetId, agentBuilderName);
  }, [
    isWorksheetDisplayed,
    isViewMode,
    isReport,
    isVantage,
    isActionBoard,
    isTreeBuilder,
    location.pathname,
    workbookName,
    worksheets,
    treeBuilderName,
    worksheetId,
    agentBuilderName,
  ]);

  return null;
};
